.root {
  --toggle-width: 54px;
  --toggle-height: 30px;
  --thumb-size: 20px;
  --thumb-offset: 2px;

  all: unset;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  /* Base styles */
  width: var(--toggle-width);
  height: var(--toggle-height);
  border-radius: var(--radius-full);
  position: relative;
  transition: background-color 200ms;
}

.root[aria-checked="true"] {
  background-color: var(--content-accent);
}

.root[aria-checked="true"]:hover:not(:disabled) {
  background-color: var(--content-link-hover);
}

.root[aria-checked="false"] {
  background-color: var(--surface-action-selection-track);
}

.root[aria-checked="false"]:hover:not(:disabled) {
  background-color: var(--surface-action-selection-track-hover);
}

/* Size variants */
.small {
  --toggle-width: 36px;
  --toggle-height: 20px;
  --thumb-size: 16px;
}

.medium {
  --toggle-width: 44px;
  --toggle-height: 24px;
  --thumb-size: 20px;
}

.large {
  --toggle-width: 54px;
  --toggle-height: 30px;
  --thumb-size: 26px;
}

/* Thumb styles */
.thumb {
  display: block;
  width: var(--thumb-size);
  height: var(--thumb-size);
  background-color: var(--surface-raised);
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-floating);
  transition: transform 200ms;
  transform: translateX(var(--thumb-offset));
}

.root[aria-checked="true"] .thumb {
  transform: translateX(calc(var(--toggle-width) - var(--thumb-size) - var(--thumb-offset)));
}

/* Disabled state */
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Focus styles */
.root:focus-visible {
  outline: var(--border-width-input-focus) solid var(--border-action-input-focus);
  outline-offset: var(--border-width-input-focus);
}

.iconContainer {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--toggle-width) - var(--thumb-size) - var(--thumb-offset) * 2);
  height: 100%;
  pointer-events: none;
  transform: translateX(calc(var(--thumb-size) + var(--thumb-offset)));
}

.root[aria-checked="true"] .iconContainer {
  transform: translateX(var(--thumb-offset));
}

.label {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}
